import { Card } from "react-bootstrap";
import useCallApi from "../../../hooks/useCallApi";

import ReportTable from '../../../templates/ReportTable/ReportTable'
import Loading from "../../../templates/UI/Loading/Loading";
import moment from "moment";
import Campaign from "../../../templates/Campaign/Campaign";
import Dollars from "../../../templates/Dollars/Dollars";
import DownloadCSV from "../../../templates/DownloadCSV/DownloadCSV";

const CustomTransactions = ({year, affiliateId}) => {
    const {data, dataLoaded} = useCallApi(`affiliate/${affiliateId}/transactionHistory/${year}`, 'GET',{}, [year, affiliateId]);

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Entry ID',
                accessor: 'entry_id',
            },
            {
                Header: 'Entry Date',
                accessor: 'entry_date',
                Cell: ({ cell: { value } }) => {
                    return <>{moment(value).format('YYYY-MM-DD')}</>
                },
                className: 'text-nowrap'
            },
            {
                Header: () => <div style={{ textAlign: 'right' }}>Amount</div>,
                className: 'text-right',
                accessor: 'amount',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value}/>
                },
            },
            {
                Header: 'Lead ID',
                accessor: 'lead_id',
            },
            {
                Header: 'Lead Date',
                accessor: 'db_date',
                Cell: ({ cell: { value } }) => {
                    return <>{moment(value).format('YYYY-MM-DD')}</>
                },
                className: 'text-nowrap'
            },
            {
                Header: 'Offer ID',
                accessor: 'offer_id',
            },
            {
                Header: 'Offer Name',
                accessor: 'offer_name',
                Cell: ({ cell: { value } }) => {
                    return <Campaign name={value} oid={data.report[0].offer_id} />
                }
            },
            {
                Header: () => <div style={{ textAlign: 'right' }}>Affiliate Rate</div>,
                className: 'text-right',
                accessor: 'affiliate_rate',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value} />
                }
            },
            {
                Header: 'Subcode 1',
                accessor: 'subcode1',
            },
            {
                Header: 'Subcode 2',
                accessor: 'subcode2',
            },
            {
                Header: 'Notes',
                accessor: 'notes',
            },
        ]

        return (
            <>
                <ReportTable
                    data={data.report}
                    columns={columns}                    
                />
            </>
        )
    }

    return (
        <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-h1-dark mr-3">Transaction Details for: {year}</h5>
                <DownloadCSV data={data.report} filename={`affiliate-${affiliateId}-transactions-${year}-for-${affiliateId}`} headerLabels={['Entry ID', 'Entry Date', 'Amount', 'Lead ID', 'Lead Date', 'Offer ID', 'Offer Name', 'Affiliate Rate', 'Subcode 1', 'Subcode 2', 'Notes']} dataLabels={['entry_id', 'entry_date', 'amount', 'lead_id', 'db_date', 'offer_id', 'offer_name', 'affiliate_rate', 'subcode1', 'subcode2', 'notes']} />
            </Card.Header>
            
            {dataLoaded ? data.report.length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading></Loading>}
            
        </Card>
    );
}

export default CustomTransactions;